import { combineReducers } from 'redux';

import account from './accountReducer';
import deathPrayers from './deathPrayersReducer';
import masses from './massesReducer';
import fetch from './fetchReducer';
import accountOptions from './accountOptionsReducer';
import paymentLink from './paymentLinkReducer';

const combinedReducers = combineReducers({
  account,
  deathPrayers,
  masses,
  fetch,
  accountOptions,
  paymentLink,
});

export default combinedReducers;
